import {
    PRODUCT_REMOVE_DESCRIPTION_ITEM,
    PRODUCT_DESCRIPTION_UPDATE,
    PRODUCT_ADD_DESCRIPTION_ITEM,
    PRODUCT_REORDER_DESCRIPTION,
} from './types'

import { showMessage } from 'store/actions'

export const removeDescriptionItem = localId => dispatch => {
    dispatch({
        type: PRODUCT_REMOVE_DESCRIPTION_ITEM,
        localId,
    })
}

export const updateDescription = (localId, name, value) => dispatch => {
    dispatch({
        type: PRODUCT_DESCRIPTION_UPDATE,
        localId,
        name,
        value,
    })
}

export const reorderDescription = (oldIndex, newIndex) => dispatch => {
    dispatch({
        type: PRODUCT_REORDER_DESCRIPTION,
        oldIndex,
        newIndex,
    })
}

export const addDescriptionItem = descriptionItem => dispatch => {
    dispatch({
        type: PRODUCT_ADD_DESCRIPTION_ITEM,
        descriptionItem,
    })
}

export const addDescriptionItemWithNotification = descriptionItem => dispatch => {
    dispatch({
        type: PRODUCT_ADD_DESCRIPTION_ITEM,
        descriptionItem,
    })

    dispatch(
        showMessage({
            message: 'Dodano blok do opisu. Pamiętaj o zapisaniu zmian!',
            autoHideDuration: 4000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
            variant: 'success',
        })
    )
}
